import React from 'react';
import RoundButton from './RoundButton';
import './PlaceholderSearch.css'


const PlaceholderSearch = () => {
    const alphabet = Array.from({length: 26}, (_, i) => String.fromCharCode(65 + i));

    const handleLetterClick = (letter) => {
        console.log(`You clicked: ${letter}`);
    };

    const placeholderData = [
        {image: "rubriken1.png"},
        {image: "rubriken2.png"},
        {image: "rubriken3.png"},
        {image: "rubriken4.png"},
        {image: "rubriken5.png"},
    ];

    return (
        <div>
            <div className="landing-title theken-search">
                    Sendungen A-Z
            </div>
            <div className='alphabet-container'>
                {alphabet.map((letter) => (
                    <RoundButton
                        key={letter}
                        letter={letter}
                        onClick={() => handleLetterClick(letter)}
                    />
                ))}
            </div>
            <div className="landing-title theken-search">Rubriken</div>
            {
                placeholderData.map((item, index) => (
                <div className="card-landing" key={index}>
                        <img src={item.image} alt={item.title} className="card-image-landing"/>
                        <div className="card-title-landing">{item.title}</div>
                </div>))
            }
        </div>
    );
};

export default PlaceholderSearch;